<template>
    <div class="content">
        <div class="backButton">
            <button @click="goToList"><i class="fas fa-arrow-left-long"></i> Back</button>
        </div>
        <div class="clientContainer" v-if="client">
            <h4>Name: <input type="text" v-model="client.clientName" :disabled="!client.isActive" @change="saveClient('clientName')" /></h4>
            <h4>Code: <input type="text" v-model="client.clientCode" :disabled="!client.isActive" @change="saveClient('clientCode')" /></h4>
            <h4>Site URL: <input type="text" v-model="client.siteUrl" :disabled="!client.isActive" @change="saveClient('siteUrl')" /></h4>
            <h4>Storage Folder Name: <input type="text" v-model="client.storageFolderName" :disabled="!client.isActive" @change="saveClient('storageFolderName')" /></h4>
            <LanguageManagement :objectLanguageArray="client.languages" :onLanguageAdd="addLanguage" :onLanguageDelete="deleteLanguage" ref="langMang"></LanguageManagement>
            <h4>Status: 
                <span v-if="client.isActive">Active</span>
                <span v-if="!client.isActive">Inactive</span>
            </h4>
            <button class="reactivateButton" v-if="!client.isActive" @click="reactivateClient">Reactivate Client</button>
            <button class="deactivateButton" v-if="client.isActive" @click="deactivateClient">Deactivate Client</button>
            <p>Show deleted elements <input type="checkbox" v-model="showDeletedElements" @change="getClient" /></p>
            <div class="logDumps">
                <ItemModal openModalButton="Migrate Storage Folder"
                            itemName="Folder Migration"
                            :formRows="storageFormRows"
                            :saveItemFunction="copyStorageFolder"
                            :isActive="client.isActive"></ItemModal>
                <ItemModal :itemName="'Activity Log CSV'"
                            :formRows="logDumpFormRows"
                            :saveItemFunction="downloadActivityLogCSV"
                            :isActive="client.isActive"
                            :openModalButton="'Download Activity Log CSV'"></ItemModal>
                <ItemModal :itemName="'Feedback CSV'"
                            :formRows="logDumpFormRows"
                            :saveItemFunction="downloadFeedbackCSV"
                            :isActive="client.isActive"
                            :openModalButton="'Download Feedback CSV'"></ItemModal>
                <ItemModal :itemName="'Scorm Data'" v-if="LmsIds.length > 0"
                            :formRows="ScormlogDumpFormRows"
                            :saveItemFunction="downloadScormCsv"
                            :isActive="client.isActive"
                            :openModalButton="'Download Scorm Data'"></ItemModal>
                <ItemModal :itemName="'Auth0 Data'"
                            :formRows="logDumpFormRows"
                            :saveItemFunction="downloadAuth0Log"
                            :isActive="client.isActive"
                            :openModalButton="'Download Auth0 Logs'"></ItemModal>
                
            </div>
        </div>
        <div class="accessContainer" v-if="client">
            <h2>Access pages</h2>
            <div class="page" v-for="page in activeItems(client.pages)" :key="page.id">
                <button v-if="page.isActive" class="deleteButton" @click="deletePage(page)" :disabled="!client.isActive">
                    Deactivate Page
                </button>
                <button v-if="!page.isActive" class="reactivateButton" @click="reactivatePage(page)" :disabled="!client.isActive">
                    Reactivate Page
                </button>
                <div class="dataEntryContainer">
                    <p>Description:</p>
                    <div class="dataRowContainer">
                        <input v-model="page.description" type="text" :disabled="!client.isActive || !page.isActive" @change="savePage(page, 'description')" />
                    </div>
                    <div></div>
                </div>                
                <div class="dataEntryContainer">
                    <p>Page Url:</p>
                    <div class="dataRowContainer">
                        <input v-model="page.pageUrl" type="text" :disabled="!client.isActive || !page.isActive" @change="savePage(page, 'pageUrl')" />
                        <a :href="getUrl(page)" target="_blank" class="launchButton" style="margin-left:20px;">Launch >></a>
                    </div>
                    <div></div>
                </div>
                <div>
                    <p>Is Url Parameterized?  (i.e. is the last part of the URL being saved above as part of the Page Url):</p>
                    <div class="dataRowContainer">
                        <input type="checkbox" v-model="page.isParameterizedUrl" :disabled="!client.isActive || !page.isActive" @change="savePage(page, 'isParameterizedUrl')" />
                    </div>
                </div>
                <div class="dataEntryContainer">
                    <p>Page Status:</p>
                    <div>
                        <select v-model="page.pageStatus" :disabled="!client.isActive || !page.isActive" @change="savePage(page, 'pageStatus')">
                            <option v-for="status in pageStatuses" :key="status.value" :value="status.internalName">{{status.displayName}}</option>
                        </select>
                    </div>
                </div>
                <div class="dataEntryContainer">
                    <p>Browser Title</p>
                    <div>
                        <input type="text" v-model="page.properties.browserTitle" :disabled="!client.isActive || !page.isActive" @change="savePage(page, 'properties')" />
                    </div>
                </div>
                <div class="dataEntryContainer">
                    <div class="flex-row">
                        <h3>Client logo:</h3>
                        <span v-if="page.logoMediaProperty" class="mpDescription">{{ page.logoMediaProperty.description }}</span>
                        <button @click="showImageModal(page)" class="openModalButton" :disabled="!page.isActive">
                            <i v-if="!page.logoMediaProperty" class="fa-circle-plus fas fa-2xl"></i>
                            <i v-if="page.logoMediaProperty" class="fa-pen-to-square fas fa-2xl"></i>
                        </button>
                        <button v-if="page.logoMediaProperty" @click="removeClientLogo(page)" class="removeMediaPropertyButton" :disabled="!page.isActive">
                            <i class="fa-trash-can fas fa-lg"></i>
                        </button>
                        <AddMediaPropertyModal v-if="page.showImageModal" mediaTypeFilter="Image"
                                                :object="page"
                                                @saveMediaProperty="saveClientLogo"
                                                :isActive="page.isActive"
                                                @hideAddMediaPropertyModal="hideImageModal(page)"></AddMediaPropertyModal>
                    </div>
                </div>
                <div class="dataEntryContainer">
                    <h3>Page Type:</h3>
                    <div style="flex-direction: row">
                        <input type="checkbox" v-model="page.isLoa" :disabled="!client.isActive || !page.isActive" @change="changeLoaCheckbox(page, $event)" />
                        <span>LOA app</span>
                    </div>
                </div>
                <div class="dataEntryContainer">
                    <h3 v-if="page.isLoa">LOA Properties:</h3>
                    <div class="flex-row">
                        <div class="property" style="margin-right: 50px;">
                            <input type="checkbox" v-if="page.isLoa && page.properties.loaProperties" v-model="page.properties.loaProperties.hasEmail" :disabled="!client.isActive || !page.isActive" @change="savePage(page, 'properties')" />
                            <span v-if="page.isLoa">Has Email</span>
                        </div>
                        <div class="property">
                            <input type="checkbox" v-if="page.isLoa && page.properties.loaProperties" v-model="page.properties.loaProperties.hasManagerPath" :disabled="!client.isActive || !page.isActive" @change="toggleHasManagerPath(page)" />
                            <span v-if="page.isLoa">Has Manager Path</span>
                        </div>
                    </div>
                    <div v-if="page.isLoa && page.properties.loaProperties && page.properties.loaProperties.hasManagerPath">
                        <div class="flexRow">
                            <h3>Manager Accordion Configuration</h3>
                            <button @click="openAccordionConfiguration(page)" class="openModalButton" :disabled="!client.isActive || !page.isActive">
                                <i class="fa-pen-to-square fas fa-2xl"></i>
                            </button>
                        </div>
                        <p v-if="page.properties.loaProperties.managerAccordionConfiguration && page.properties.loaProperties.managerAccordionConfiguration.accordionCode">Accordion Code: {{ page.properties.loaProperties.managerAccordionConfiguration.accordionCode }}</p>
                    </div>
                </div>
                <div class="dataEntryContainer" v-if="page.isLoa && page.properties.loaProperties && page.properties.loaProperties.hasEmail">
                    <div class="flex-row">
                        <h3>Email Template:</h3>
                        <span v-if="page.emailTemplateMediaProperty" class="mpDescription">{{ page.emailTemplateMediaProperty.description }}</span>
                        <button @click="showEmailTemplateModal(page)" class="openModalButton" :disabled="!page.isActive">
                            <i v-if="!page.emailTemplateMediaProperty" class="fa-circle-plus fas fa-2xl"></i>
                            <i v-if="page.emailTemplateMediaProperty" class="fa-pen-to-square fas fa-2xl"></i>
                        </button>
                        <button v-if="page.emailTemplateMediaProperty" @click="removeEmailTemplate(page)" class="removeMediaPropertyButton" :disabled="!page.isActive">
                            <i class="fa-trash-can fas fa-lg"></i>
                        </button>
                        <AddMediaPropertyModal v-if="page.showEmailTemplateModal" mediaTypeFilter="EmailTemplate"
                                            :object="page"
                                            @saveMediaProperty="saveEmailTemplate"
                                            :isActive="page.isActive"
                                            @hideAddMediaPropertyModal="hideEmailTemplateModal(page)"></AddMediaPropertyModal>
                    </div>
                </div>
                <div class="dataEntryContainer">
                    <h3 class="flex-row">
                        Feedback Configurations:
                        <div @click="addFeedbackConfiguration(page)" class="addItem" :disabled="!client.isActive">
                            <i class="fa-circle-plus fas fa-2xl"></i> Add feedback configuration
                        </div>
                    </h3>
                    <div v-if="page.properties.feedbackProperties.length">
                        <div v-for="(config, index) in page.properties.feedbackProperties" :key="config.key" class="feedbackConfiguration">
                            <div class="feedbackProperty" style="width:35px;">
                                <div v-if="index == 0">Active</div>
                                <input type="checkbox" v-model="config.allowFeedback" :disabled="!client.isActive || !page.isActive" @change="savePage(page, 'properties')" />
                            </div>
                            <div class="feedbackProperty">
                                <div v-if="index== 0">Project ID</div>
                                <input type="text" v-model="config.projectID" :disabled="!client.isActive || !page.isActive" @blur="savePage(page, 'properties')" />
                            </div>
                            <div class="feedbackProperty">
                                <div v-if="index==0">Feedback Guid</div>
                                <input type="text" v-model="config.feedbackGUID" :disabled="!client.isActive || !page.isActive" @blur="savePage(page, 'properties')" />
                            </div>
                            <div class="IconContainer">
                                <button @click="deleteFeedbackConfiguration(index, page)" class="deleteIcon" :disabled="!client.isActive">
                                    <i class="fa-trash-can fas fa"></i>
                                </button>
                            </div>
                            <div class="IconContainer">
                                <a v-if="config.allowFeedback" :href="getUrl(page, config.feedbackGUID )" target="_blank" class="launchButton">>></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dataEntryContainer">  
                    <h3 style="display:flex; flex-direction: row">
                        Defined Constants:
                        <div @click="addConstant(page)" class="addItem" :disabled="!client.isActive">
                            <i class="fa-circle-plus fas fa-2xl"></i> Add Constant
                        </div>
                    </h3>
                    <div v-if="page.definedValues.length">
                        <div v-for="(definedValue, index) in page.definedValues" :key="index" class="defined-values">
                            <div class="defined-value-container">
                                <div class="attributes">
                                    <select v-model="definedValue.key" @change="savePage(page, 'definedValues')">
                                        <option  value='' selected>Choose Attribute</option>
                                        <option v-for="(attribute, index) in attributes" v-bind:key="index" :value="attribute.code">{{attribute.code}}</option>
                                    </select>
                                </div>
                                <div class="values">
                                    <div class="language-value" v-for="(val, valIndex) in definedValue.valueJson" :key="val.language">
                                        <div class="language-name" v-if="client.languages.length > 1">{{ val.language }}</div>
                                        <div style="display: flex;">
                                            <input type="text" v-model="val.text" :disabled="!client.isActive || !page.isActive" @blur="savePage(page, 'definedValues')" />
                                            <div class="IconContainer" v-if="definedValue.valueJson.length === 1 || val.language !== 'English'">
                                                <button @click="deleteConstant(index, page, valIndex)" class="deleteIcon" :disabled="!client.isActive">
                                                    <i class="fa-trash-can fas fa"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="IconContainer" v-if="client.languages.length > 1 && definedValue.valueJson.length < client.languages.length">
                                        <button @click="definedValue.addingLanguage = true" class="add-icon" :disabled="!client.isActive" v-if="!definedValue.addingLanguage">
                                            <i class="fa-circle-plus fas fa"></i>
                                        </button>
                                        <select v-if="definedValue.addingLanguage" @change="addValueToConstant(definedValue)" v-model="definedValue.language">
                                            <option :val="undefined" disabled>-- Select language --</option>
                                            <option v-for="lang in availableLanguages(definedValue.valueJson)" :key="lang.name" :val="lang.name">{{ lang.name }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ItemModal :itemName="'Access Page'"
                                :formRows="newClientAccessFormRows"
                                :saveItemFunction="savePage"
                                :refreshItemsFunction="getClient"
                                :isActive="client.isActive"></ItemModal>
            <AccordionConfiguration v-if="activeAccordionConfigurationPage"
                            :configuration="activeAccordionConfigurationPage.properties.loaProperties.managerAccordionConfiguration"
                            :parentObject="activeAccordionConfigurationPage"
                            :onFieldUpdate="saveManagerAccordionConfig"
                            :onModalClose="closeAccordionConfiguration"></AccordionConfiguration>
        </div>
    </div>
</template>

<script>
import {data} from '../../shared/data'
import ItemModal from '@/components/ItemModal.vue'
import {sorting} from '../../shared/sorting';
import {translation} from '../../shared/translation';
import { downloadCsv } from '@/shared/downloadCsv';
import AddMediaPropertyModal from '@/components/mediaproperty/AddMediaPropertyModal.vue';
import AccordionConfiguration from '@/components/accordion/AccordionConfiguration.vue';
import LanguageManagement from '../shared/LanguageManagement.vue';

export default {
    name: 'ClientEdit',
    components: { ItemModal, AddMediaPropertyModal, AccordionConfiguration, LanguageManagement },
    data: function() {
        const storageBuckets = [
                {displayName: 'Production', internalName: 'jv.production'},
                {displayName: 'QA', internalName: 'jv.qa.new'},
                {displayName: 'Development', internalName: 'jv.development'}
            ];
        return {
            client: null,
            attributes: [],
            showDeletedElements: false,
            pageStatuses: [],
            baseUrl: '',
            activeAccordionConfigurationPage: null,
            storageFormRows: [
                {
                    name: 'Copy from',
                    propertyName: 'fromBucket',
                    required: true,
                    element: 'select',
                    selectOptions: storageBuckets
                },
                {
                    name: 'Copy to',
                    propertyName: 'toBucket',
                    required: true,
                    element: 'select',
                    selectOptions: storageBuckets
                }
            ],
            newClientAccessFormRows: [
                {
                    name: 'Page URL',
                    propertyName: 'pageUrl',
                    required: true,
                    element: 'input'
                },
                {
                    name: 'Page Status',
                    propertyName: 'pageStatus',
                    required: true,
                    element: 'select'
                }
            ],
            logDumpFormRows: [
                {
                    name: 'Start Date',
                    propertyName: 'startDate',
                    element: 'date'
                },
                {
                    name: 'End Date',
                    propertyName: 'endDate',
                    element: 'date'
                },
                {
                    element: 'text',
                    text: 'Leave dates empty to retrieve all records'
                }
            ]
        };
    },
    computed: {
        LmsIds() {
            if(!this.client || !this.client.pages || !this.attributes) return [];
            var lmsCourseAttribute = this.attributes.find((attribute) => attribute.code === 'LMS_COURSE_ID');
            if(lmsCourseAttribute == null) return [];

            var registrationIds = [];
            this.client.pages.forEach((page) => {
                var courseAttribute = page.definedValues.find((element) => element.key == lmsCourseAttribute.code);
                if(courseAttribute)
                    registrationIds.push(translation.getTranslatedText( 'English', courseAttribute.valueJson))
            });
            return registrationIds;            
        },
        ScormlogDumpFormRows() {
            var rows = JSON.parse(JSON.stringify(this.logDumpFormRows)); 
            var idsForBinding = [];
            this.LmsIds.forEach(obj => {
                idsForBinding.push( {
                    internalName: obj,
                    value: obj, 
                    displayName: obj
                });
            });

            if(this.LmsIds.length > 1) {
                rows.unshift({
                    name: 'Course ID',
                    propertyName: 'courseId',
                    element: 'select',
                    selectOptions: idsForBinding
                })
            }

            return rows;
        }
    },
    async mounted() {
        var attributes = await data.getAllAttributes('', true);
        this.attributes = sorting.sortArray(attributes, 'code', 'asc');

        await this.getClient();
        this.getPageStatuses();

        this.baseUrl = window.location.origin;

        if(this.baseUrl.toLowerCase().indexOf("qa") >= 0 ||
            this.baseUrl.toLowerCase().indexOf("dev") >= 0) 
        {
            this.baseUrl = this.baseUrl.replace('admin-', '').replace('custom-solutions', 'custom-solutions-web') + '/%page%';
                
            if(this.client.siteUrl !== '*')
                this.baseUrl = this.baseUrl + '?impersonate_url=%site%';
        }
        else if(this.baseUrl.indexOf("localhost") >= 0)
        {
            this.baseUrl = 'http://localhost:5173/%page%';
            if(this.client.siteUrl !== '*')
                this.baseUrl = this.baseUrl + '?impersonate_url=%site%&debug=true';
        }
        else if(this.client.siteUrl !== '*')
            this.baseUrl = "https://%site%/%page%?skip_logging=1";
        else 
            this.baseUrl = "https://jellyvisioncustom.com/%page%";
    },
    methods: {
        toggleHasManagerPath(page) {
            if(!page.properties.loaProperties.hasManagerPath) {
                page.properties.loaProperties.managerAccordionConfiguration = null;
            }

            this.savePage(page, 'properties');
        },
        getUrl: function(page, feedbackCode) {
            var pageUrl = this.baseUrl.replace("%site%", this.client.siteUrl).replace("%page%", page.pageUrl);

            if(page.pageStatus.indexOf("ComingSoon") >= 0)
                pageUrl = pageUrl + "&ignore_coming_soon=true";
            
        
            if(feedbackCode) 
                pageUrl = pageUrl + "&feedbackCode=" + feedbackCode;

            return pageUrl;
        },
        getClient: async function() {
            const urlParams = new URLSearchParams(window.location.search);
            this.client = await data.getClient(urlParams.get('ID'));
            this.client.pages.forEach(page => {
                if(!page.properties)
                    page.properties = {feedbackProperties:[]};
                if(page.properties.feedbackProperties.constructor != Array)
                    page.properties.feedbackProperties = [];
                if(page.properties.loaProperties)
                    page.isLoa = true;
                else
                    page.isLoa = false;
            });
        },
        getPageStatuses: async function() {
            this.pageStatuses = await data.getEnumList('PageStatuses');
            this.newClientAccessFormRows.find(row => row.propertyName == 'pageStatus').selectOptions = this.pageStatuses;
        },
        saveClient: async function(fieldName) {
            let obj = {};
            if(fieldName) {
                obj.id = this.client.id;
                obj[fieldName] = this.client[fieldName];
            } else {
                obj = this.client;
            }
            this.processSaveResult(await data.saveClient(obj));
        },
        reactivateClient: async function() {
            this.client.isActive = true;
            this.processReactivateResult(await data.saveClient(this.client));
        },
        deactivateClient: async function() {
            if(confirm('Are you sure you want to deactivate this client?')) {
                this.client.isActive = false;
                this.processDeactivateResult(await data.saveClient(this.client));
            }
        },
        savePage: async function(page, fieldName) {
            let obj = {};
            if(fieldName) {
                obj.id = page.id;
                obj[fieldName] = page[fieldName];
            } else {
                obj = page;
            }

            obj.clientId = this.client.id;
            return this.processSaveResult(await data.saveClientAccess(obj));
        },
        deletePage: async function(page) {
            if(confirm('Are you sure you want to deactivate this page?')) {
                page.isActive = false;
                this.processDeactivateResult(await data.saveClientAccess(page));
            }
        },
        reactivatePage: async function(page) {
            page.isActive = true;
            this.processReactivateResult(await data.saveClientAccess(page));
        },
        goToList: function() {
            window.location.href = '/clients';
        },
        activeItems: function(itemArr) {
            if(itemArr)
                return itemArr.filter(i => this.showDeletedElements || i.isActive);
        },
        changeLoaCheckbox: function(page, event) {
            if(event.target.checked) {
                page.properties.loaProperties = {
                    hasEmail: false,
                    hasManagerPath: false
                };
            } else {
                page.properties.loaProperties = null;
            }
            this.savePage(page, 'properties');
        },
        addFeedbackConfiguration: function(page) {
            const key = page.properties.feedbackProperties.length ? page.properties.feedbackProperties[page.properties.feedbackProperties.length - 1].key + 1 : 0;
            page.properties.feedbackProperties.push({
                active: false,
                feedbackGUID: '',
                projectID: '',
                key: key
            });
            this.savePage(page, 'properties');
        },
        deleteFeedbackConfiguration(index, page) {
            page.properties.feedbackProperties.splice(index, 1);
            this.savePage(page, 'properties');
        },
        addConstant: function(page) {
            page.definedValues.push({ key: "", valueJson: [{language:'English', text:''}]});
        },
        deleteConstant(index, page, valIndex) {
            if(page.definedValues[index].valueJson.length > 1) {
                if(confirm(`Are you sure you want to delete the ${page.definedValues[index].valueJson[valIndex].language} translation of ${page.definedValues[index].key}?`))
                    page.definedValues[index].valueJson.splice(valIndex, 1);
            } else {
                if(confirm(`Are you sure you want to delete the ${page.definedValues[index].key} constant?`))
                    page.definedValues.splice(index, 1);
            }
            this.savePage(page, 'definedValues');
        },
        downloadActivityLogCSV: async function(dates) {
            downloadCsv.downloadCsvWithDates(dates, data.getActivityLogs, this.client.clientCode, 'Activity_Logs');
        },
        downloadFeedbackCSV: async function(dates) {

            downloadCsv.downloadCsvWithDates(dates,  data.getClientFeedback, this.client.clientCode, 'Feedback');

        },
        downloadScormCsv: async function(searchValues) {
            var data1 = await data.getLmsData(searchValues.courseId, searchValues.startDate, searchValues.endDate);  
            
            downloadCsv.downloadCsvFile(data1, downloadCsv.createFileName(searchValues.startDate, searchValues.endDate, this.client.clientCode, 'Scorm_Interactions')  );
        },
        downloadAuth0Log : async function(searchValues) {
            var data1 = await data.getAuth0Log(searchValues.startDate, searchValues.endDate);              
            downloadCsv.downloadCsvFile(data1, downloadCsv.createFileName(searchValues.startDate, searchValues.endDate, '', 'Auth0Logs')  );
        },
        saveClientLogo: async function(page, mp) {
            page.logoMediaPropertyId = mp.id;
            await this.savePage(page, 'logoMediaPropertyId');
            page.logoMediaProperty = await data.getMediaProperty(mp.id);
        },
        saveEmailTemplate: async function(page, mp) {
            page.properties.emailTemplateMediaPropertyId = mp.id;
            await this.savePage(page, 'properties');
            page.emailTemplateMediaProperty = await data.getMediaProperty(mp.id);
        },
        removeClientLogo: async function(page) {
            page.logoMediaPropertyId = 0;
            page.logoMediaProperty = {};
            this.processDeleteResult(await this.savePage(page, 'logoMediaPropertyId'));
        },
        removeEmailTemplate: async function(page) {
            page.properties.emailTemplateMediaPropertyId = 0;
            page.emailTemplateMediaProperty = {};
            this.processDeleteResult(await this.savePage(page, 'properties'));
        },
        showImageModal: function(page) {
            page.showImageModal = true;
        },
        hideImageModal: function(page) {
            page.showImageModal = false;
        },
        showEmailTemplateModal: function(page) {
            page.showEmailTemplateModal = true;
        },
        hideEmailTemplateModal: function(page) {
            page.showEmailTemplateModal = false;
        },
        saveManagerAccordionConfig: async function(accConfig, page) {
            page.properties.loaProperties.managerAccordionConfiguration = accConfig;
            await this.savePage(page, 'properties');
        },
        openAccordionConfiguration: function(page) {
            if(!page.properties.loaProperties.managerAccordionConfiguration)
                page.properties.loaProperties.managerAccordionConfiguration = {};
            this.activeAccordionConfigurationPage = page;
        },
        closeAccordionConfiguration: function() {
            this.activeAccordionConfigurationPage = null;
        },
        copyStorageFolder: async function(buckets) {
            if(buckets.fromBucket === buckets.toBucket) {
                alert('Must select different buckets');
                return;
            }
            if(!this.client.storageFolderName) {
                alert('Must set a Storage Folder Name');
                return;
            }
            const saveObj = {
                fromBucket: buckets.fromBucket,
                toBucket: buckets.toBucket,
                fromFolder: this.client.storageFolderName,
                toFolder: this.client.storageFolderName
            };

            return this.processSaveResult(await data.copyStorageObject(saveObj));
        },
        addLanguage: async function(lang) {
            this.client.languages.push(lang);
            await this.saveClient('languages');
        },
        deleteLanguage: async function(lang) {
            this.client.languages.splice(this.client.languages.indexOf(lang), 1);
            await this.saveClient('languages');
        },
        availableLanguages(value) {
            return this.$refs.langMang.languages.filter(lang => !value.find(val => val.language === lang.name));
        },
        addValueToConstant: function(definedValue) {
            definedValue.valueJson.push({language: definedValue.language, text: ''});
            definedValue.addingLanguage = false;
        }
    }
}
</script>

<style scoped>
    .content {
        display: flex;
        text-align: left;
    }
    .clientContainer {
        flex: 1 1 100px;
        padding-left: 100px;
    }
    .accessContainer {
        flex: 3 1 200px;
        border-left: 1px solid lightgray;
        padding-left: 50px;
    }
    .reactivateButton {
        height: 40px;
        width: 200px;
        border-radius: 5px;
        background-color: lightgreen;
        border-color: lightgreen;
        font-size: 16px;
        cursor: pointer;
        margin-bottom: 10px;
    }
    .page .reactivateButton {
        position: absolute;
        right: 10px;
    }
    .deactivateButton {
        height: 40px;
        width: 200px;
        border-radius: 5px;
        background-color: darkred;
        border-color: darkred;
        color: white;
        font-size: 16px;
        cursor: pointer;
        margin-bottom: 10px;
    }

    :deep(.logDumps .openModalButton) {
        height: 40px;
        width: 250px;
        font-size: 16px;
        background-color: #036991;
        border-color: #036991;
        color: white;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        margin-bottom: 10px;
    }
    .deleteButton {
        position: absolute;
        height: 40px;
        width: 200px;
        font-size: 16px;
        background-color: darkred;
        border-color: darkred;
        color: white;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        right: 10px;
        top: -25px;
    }
    .deleteButton:disabled {
        color: gray;
    }
    .page {
        display: flex;
        flex-direction: column;
        width: 100%;
        position: relative;
        border-bottom: 1px solid lightgray;
        margin-bottom: 20px;
    }

    .dataEntryContainer {
        display: flex; 
        flex-direction: column;
    }

    .dataRowContainer {
        display: flex;
        flex-direction: row;
    }

    .feedbackConfiguration {
        position: relative;
        display:flex;
        flex-direction: row;
        margin-top: -10px;
    }

    .flex-row {
        display:flex;
        flex-direction: row;
    }

    .IconContainer {
        display: flex; 
        align-items: flex-end;
        padding-bottom: 10px;
        padding-right: 10px;
        margin-left: 10px;
    }
  
    .deleteIcon {
        padding: 5px;
        background-color: darkred;
        border-color: darkred;
        color: white;
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
    .add-icon {
        padding: 5px;
        background-color: #036991;
        border-color: #036991;
        color: white;
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
    .addItem {
        background-color: unset;
        border: none;
        cursor: pointer;
        font-size: 16px;
        color:#036991;
        margin-left: 30px;
    }

    .feedbackProperty {
        padding: 10px 10px;
    }

    .feedbackProperty div {
        margin-bottom: 10px; 
    }

    .launchButton {
        justify-content: center; 
        align-items: center; 
        color: black;
        display: flex; 
        border: 1px solid black; 
        text-decoration: none; 
        background-color: #FFD831; 
        padding: 4px; 
        border-radius: 5px; 
        font-size: 14px;
        font-weight: bold;
    }
    .openModalButton {
        display: inline-block;
        background-color: unset;
        border: none;
        cursor: pointer;
        font-size: 12px;
        color:#036991;
    }
    .editFieldButton {
        display: inline-block;
        background-color: unset;
        border: none;
        cursor: pointer;
        color:#036991;
        margin-left: 10px;
    }
    .removeMediaPropertyButton {
        display: inline-block;
        background-color: unset;
        border: none;
        cursor: pointer;
        font-size: 12px;
        color:darkred;
    }
    .mpDescription {
        margin: 17px 10px 0 10px;
    }
    .defined-values {
        position: relative;
        display:flex;
        flex-direction: row;
    }
    .defined-value-container {
        display: flex;
        flex-direction: row;
        padding: 10px 0;
        border-bottom: 1px solid gray;
    }
    .defined-value-container .attributes, .defined-value-container .values{
        display: flex;
        flex-direction: column;
    }
    .defined-value-container .attributes {
        padding: 20px 20px 10px 0;
    }
    .defined-value-container .values {
        padding-right: 15px;
    }
    .defined-value-container .values > .IconContainer {
        margin-top: 10px;
    }
    .defined-value-container .values .language-name {
        margin-bottom: 5px;
    }
    .language-value {
        margin: 20px 0 10px 0;
    }
    .values .language-value:last-of-type {
        margin-bottom: 0;
    }
</style>